module.exports = __webpack_public_path__ + "img/pr-5.52b88a0f.png";